<div class="invoice-prv2 show pt-0" *ngIf="basicInfo && quotationDetail">
	<a (click)="changeTab.emit('all-quotes')" href="javascript:void(0)" id="closeNew"
		class="closePrvinvoice close-circle">
		<svg xmlns="http://www.w3.org/2000/svg" width="42" height="44" viewBox="0 0 42 44">
			<g fill="none" fill-rule="evenodd">
				<g fill="#343434">
					<path
						d="M23.475 21.309l7.512-7.623c.685-.695.685-1.817 0-2.511-.684-.695-1.79-.695-2.474 0L21 18.798l-7.513-7.623c-.684-.695-1.79-.695-2.474 0-.684.694-.684 1.816 0 2.51l7.513 7.624-7.513 7.623c-.684.694-.684 1.817 0 2.51.341.347.79.521 1.237.521.448 0 .896-.174 1.237-.52L21 23.82l7.513 7.623c.341.346.79.52 1.237.52.448 0 .896-.174 1.237-.52.685-.694.685-1.817 0-2.51l-7.512-7.624z"
						transform="translate(-896 -298) translate(458 250) translate(438 48.706)" />
				</g>
			</g>
		</svg>
	</a>
	<div class="page-size">
		<div class="prev-invoice__leftSection quotation-reciever-view__invoice" [ngClass]="{'quotation-reciever-view__invoice--noTopPadding': quotationDetail.status != 'pending' }">
			<ng-container *ngIf="quotationDetail.status == 'approved'">
				<div class="quotation-reciever-view-accepted__title" >
					<svg width="26" height="27" viewBox="0 0 26 27" fill="none" xmlns="http://www.w3.org/2000/svg">
						<circle cx="12.9817" cy="13.5" r="12.8763" fill="white"/>
						<path d="M20.3002 8.81148C20.3002 8.81148 14.2012 14.9105 10.2932 18.8186L6.48633 14.8767" stroke="#25D366" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"/>
					</svg>
					<h1 i18n="@@quotation.quotation_accepted">Quotation Accepted</h1>
				</div>
				<div class="quotation-reciever-view-accepted__info" *ngIf="!quotationDetail.invoice_id">
					<div class="quotation-reciever-view-accepted__texts" ></div>
					<div class="quotation-reciever-view-accepted__editButton" >
						<a href="javascript:void(0);" (click)="quotationActions('convert_to_invoice')" class="tu-btn blue icon-left" >
							<svg width="23" height="23" viewBox="0 0 23 23" fill="none" xmlns="http://www.w3.org/2000/svg">
								<path fill-rule="evenodd" clip-rule="evenodd" d="M15.9399 10.0609L13.0059 7.12318L15.1266 4.99866L18.0595 7.93528L15.9399 10.0609ZM8.38571 17.6325L5.14479 17.9279L5.43219 14.7056L11.5471 8.58278L14.4822 11.5216L8.38571 17.6325ZM19.6249 6.419L19.6239 6.41791L16.6431 3.43333C15.8364 2.62777 14.4506 2.58962 13.6863 3.35811L3.89284 13.1643C3.53794 13.5186 3.31803 13.9895 3.27231 14.4876L2.85971 19.0332C2.83141 19.3548 2.94571 19.6731 3.17433 19.902C3.38009 20.108 3.65769 20.2214 3.94401 20.2214C3.97776 20.2214 4.01041 20.2203 4.04307 20.217L8.58275 19.8039C9.08135 19.7581 9.55056 19.539 9.90437 19.1847L19.699 9.37743C20.4915 8.58168 20.4578 7.25399 19.6249 6.419Z" fill="white"/>
								<mask id="mask0_454_26032" style="mask-type:alpha" maskUnits="userSpaceOnUse" x="2" y="2" width="19" height="19">
								<path fill-rule="evenodd" clip-rule="evenodd" d="M15.9399 10.0609L13.0059 7.12318L15.1266 4.99866L18.0595 7.93528L15.9399 10.0609ZM8.38571 17.6325L5.14479 17.9279L5.43219 14.7056L11.5471 8.58278L14.4822 11.5216L8.38571 17.6325ZM19.6249 6.419L19.6239 6.41791L16.6431 3.43333C15.8364 2.62777 14.4506 2.58962 13.6863 3.35811L3.89284 13.1643C3.53794 13.5186 3.31803 13.9895 3.27231 14.4876L2.85971 19.0332C2.83141 19.3548 2.94571 19.6731 3.17433 19.902C3.38009 20.108 3.65769 20.2214 3.94401 20.2214C3.97776 20.2214 4.01041 20.2203 4.04307 20.217L8.58275 19.8039C9.08135 19.7581 9.55056 19.539 9.90437 19.1847L19.699 9.37743C20.4915 8.58168 20.4578 7.25399 19.6249 6.419Z" fill="white"/>
								</mask>
								<g mask="url(#mask0_454_26032)">
								</g>
							</svg>
							<span i18n="@@quotation.Convert_to_invoice">Convert to Invoice</span>
						</a>
					</div>
				</div>
			</ng-container>

			<ng-container *ngIf="quotationDetail.status == 'rejected'">
				<div class="quotation-reciever-view-rejected__title">
					<svg width="26" height="27" viewBox="0 0 26 27" fill="none" xmlns="http://www.w3.org/2000/svg">
						<circle cx="12.8763" cy="13.5" r="12.8763" fill="white"/>
						<path d="M18.1946 8.81148L8.18749 18.8186M8.11768 9.09127L17.7749 18.7484" stroke="#FB4575" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"/>
					</svg>
					<h1 i18n="@@quotation.quotation_reject">Quotation Rejected</h1>
				</div>
				<div class="quotation-reciever-view-rejected__info">
					<div class="quotation-reciever-view-rejected__texts" >
						<h2 i18n="@@quotation.rejection_reason">Rejection Reason</h2>
						<p>{{ quotationDetail.reason }}</p>
					</div>
					<div class="quotation-reciever-view-rejected__editButton" >
						<a href="javascript:void(0);" (click)="quotationActions('edit')" class="tu-btn blue icon-left" >
							<svg width="23" height="23" viewBox="0 0 23 23" fill="none" xmlns="http://www.w3.org/2000/svg">
								<path fill-rule="evenodd" clip-rule="evenodd" d="M15.9399 10.0609L13.0059 7.12318L15.1266 4.99866L18.0595 7.93528L15.9399 10.0609ZM8.38571 17.6325L5.14479 17.9279L5.43219 14.7056L11.5471 8.58278L14.4822 11.5216L8.38571 17.6325ZM19.6249 6.419L19.6239 6.41791L16.6431 3.43333C15.8364 2.62777 14.4506 2.58962 13.6863 3.35811L3.89284 13.1643C3.53794 13.5186 3.31803 13.9895 3.27231 14.4876L2.85971 19.0332C2.83141 19.3548 2.94571 19.6731 3.17433 19.902C3.38009 20.108 3.65769 20.2214 3.94401 20.2214C3.97776 20.2214 4.01041 20.2203 4.04307 20.217L8.58275 19.8039C9.08135 19.7581 9.55056 19.539 9.90437 19.1847L19.699 9.37743C20.4915 8.58168 20.4578 7.25399 19.6249 6.419Z" fill="white"/>
								<mask id="mask0_454_26032" style="mask-type:alpha" maskUnits="userSpaceOnUse" x="2" y="2" width="19" height="19">
									<path fill-rule="evenodd" clip-rule="evenodd" d="M15.9399 10.0609L13.0059 7.12318L15.1266 4.99866L18.0595 7.93528L15.9399 10.0609ZM8.38571 17.6325L5.14479 17.9279L5.43219 14.7056L11.5471 8.58278L14.4822 11.5216L8.38571 17.6325ZM19.6249 6.419L19.6239 6.41791L16.6431 3.43333C15.8364 2.62777 14.4506 2.58962 13.6863 3.35811L3.89284 13.1643C3.53794 13.5186 3.31803 13.9895 3.27231 14.4876L2.85971 19.0332C2.83141 19.3548 2.94571 19.6731 3.17433 19.902C3.38009 20.108 3.65769 20.2214 3.94401 20.2214C3.97776 20.2214 4.01041 20.2203 4.04307 20.217L8.58275 19.8039C9.08135 19.7581 9.55056 19.539 9.90437 19.1847L19.699 9.37743C20.4915 8.58168 20.4578 7.25399 19.6249 6.419Z" fill="white"/>
								</mask>
								<g mask="url(#mask0_454_26032)">
								</g>
							</svg>
							<span i18n="@@quotation.edit_and_resend_quotation">Edit and Resend</span>
						</a>
					</div>
				</div>
			</ng-container>

			<div class="quotation-reciever-view__header" *ngIf="quotationDetail.status == 'pending'">
				<div class="quotation-reciever-view__title">
					<p i18n="@@quotations">Quotations</p>
				</div>
				<div class="wrapper no-wrapper">
					<hr class="hr-row quotation-reciever-view__line">
				</div>
			</div>
			
			<div class="wrapper quotation-reciever-view__headerdata" [ngClass]="{'quotation-reciever-view__headerdata--topPadding': quotationDetail.status != 'pending' }">
				<div class="logoArea">
					<div class="logo-image">
						<a href="javascript:void(0)" *ngIf="basicInfo.has_logo">
							<img src="{{ basicInfo.logo }}" alt="logo" loading="lazy">
						</a>
						<p class="quotation-reciever-view__name" >{{ basicInfo.business_name | titlecase }}</p>
					</div>
				</div>
				<div class="priceSection quotation-reciever-view__headerMetaData">
					<span class="total-due"i18n="@@invoices.preview.total_amount_due" [attr.style]="'color:'+prefTextColor | safe:'style'">TOTAL AMOUNT DUE</span>
					<span class="amount">
						<span class="sar" [innerHtml]="quotationDetail?.currency"></span>
						{{ quotationDetail.sub_total | number:'.2' }}
					</span>
				</div>
			</div>

			<div class="wrapper no-wrapper">
				<hr class="hr-row">
			</div>

			<div class="wrapper">
				<div class="taxSection">
					<span class="name">{{ quotationDetail.client.full_name }}</span>
					<span class="tax-no" *ngIf="quotationDetail.user.tax_number">
						<ng-container i18n="@@invoices.preview.tax_no">TIN:</ng-container> {{ quotationDetail.user.tax_number }}
					</span>
				</div>
				<div class="date-and-no">
					<span class="number" [attr.style]="'color:'+prefTextColor | safe:'style'">#{{ quotationDetail.quotation_number }}</span>
					<span class="date">{{ quotationDetail.quotation_date | date:'dd/MM/yyyy' }}</span>
				</div>
			</div>

			<div class="wrapper no-wrapper">
				<hr class="hr-row">
			</div>

			<div class="prev-invoice__tableSection quotation-reciever-view__tableSection">
				<div class="wrapper">
					<table>
						<thead>
							<tr>
								<th class="item-title" [attr.style]="'color:'+prefTextColor | safe:'style'" i18n="@@invoices.preview.item_cap">ITEM</th>
								<th class="item-amount" [attr.style]="'color:'+prefTextColor | safe:'style'" i18n="@@invoices.preview.amount_cap">AMOUNT</th>
							</tr>
						</thead>
						<tbody>
							<ng-container *ngIf="quotationDetail.items && quotationDetail.items.length; else noItem">
								<tr *ngFor="let deliverable of quotationDetail.items; index as $index; first as isFirst; last as isLast"
									[ngClass]="{'dotted-border': isFirst, 'b-dotted-border':isLast && !taxAmount }">
									<td class="item-title">
										<span class="count-num">{{ deliverable.quantity }} X</span>&rlm;
										{{ deliverable.title }}
									</td>
									<td class="item-amount">
										<span class="sar-cur" [innerHtml]="quotationDetail?.currency"></span>
										{{ deliverable.quantity * deliverable.rate | number:'.2' }}
									</td>
								</tr>

								<tr class="dashed-border-top" *ngIf="taxAmount">
									<td class="item-title">
										<ng-container i18n="@@tax">VAT</ng-container>({{ quotationDetail.tax_percent }}%)
									</td>
									<td class="item-amount">
										<span class="sar-cur" [innerHtml]="quotationDetail?.currency"></span>
										{{ newDeliverableTax | number:'1.0-2' }}
									</td>
								</tr>

								<!-- <tr class="dashed-border-bottom" *ngIf="taxAmount">
									<td class="item-title">
										<ng-container i18n="@@invoices.discount">Discount</ng-container>({{ quotationDetail.tax_percent }}%)
									</td>
									<td class="item-amount">{{ taxAmount | number:'.2' }}
										<span class="sar-cur">{{ basicInfo.currency_symbol }}</span>
									</td>
								</tr> -->

							</ng-container>
							<ng-template #noItem>
								<tr>
									<td class="text-center" [attr.colspan]="quotationDetail.tax_percent ? 4 : 3" i18n="@@invoices.no_deliverable"> No deliverable</td>
								</tr>
							</ng-template>
						</tbody>
					</table>
				</div>
			</div>
			
			<div class="wrapper">
				<div class="prev-invoice__totalSection quotation-reciever-view__totalSection">
					<ul>
						<li *ngIf="quotationDetail.original_amount != null">
							<span class="totalAmount simplified-invoice__totalSection--black" i18n="@@invoices.total">Total</span>
							<span class="totalRate simplified-invoice__totalSection--black">
								<span class="sar-cur" [innerHtml]="quotationDetail?.currency"></span>
								{{ newSubTotalDeliverableCost | number:'.2' }}
							</span>
						</li>

						<li *ngIf="quotationDetail.discounted_amount != null">
							<span class="totalAmount simplified-invoice__totalSection--black">
								<ng-container i18n="@@invoices.discount">Discount</ng-container> ({{ quotationDetail.discount }}%)
							</span>
							<span class="totalRate simplified-invoice__totalSection--black">
								<span class="sar-cur" [innerHtml]="quotationDetail?.currency"></span>
								{{ quotationDetail.discounted_amount | number:'.2' }}
							</span>
						</li>

						<li *ngIf="quotationDetail.delivery_fee != null">
							<span class="totalAmount simplified-invoice__totalSection--black">
								<ng-container i18n="@@invoices.delivery_fees">Delivery Fees</ng-container>
							</span>
							<span class="totalRate simplified-invoice__totalSection--black">
								<span class="sar-cur" [innerHtml]="quotationDetail?.currency"></span>
								{{ quotationDetail.delivery_fee | number:'.2' }}
							</span>
						</li>

						<li>
							<span class="totalAmount simplified-invoice__totalSection--black" i18n="@@invoices.preview.total_amount">Total Amount</span>
							<span class="totalRate simplified-invoice__totalSection--black" >
								<span class="sar-cur" [innerHtml]="quotationDetail?.currency"></span>
								{{ quotationDetail.sub_total | number:'.2' }}
							</span>
						</li>
					</ul>
				</div>
			</div>

			<div class="wrapper" *ngIf="quotationDetail.additional_info">
				<div class="quotation-reciever-view-additionalInfo">
					<div class="quotation-reciever-view-additionalInfo__header" >
						<p i18n="@@invoices.additional_info">Additional Information</p>
						<div></div>
					</div>
					<div class="quotation-reciever-view-additionalInfo__body">
						<p class="pre-text">{{ quotationDetail.additional_info }}</p>
					</div>
				</div>				
			</div>
		</div>

		<div class="quotation-reciever-view-additionalInfo__actions" *ngIf="quotationDetail.status == 'pending'">
			<div class="quotation-reciever-view-additionalInfo__btns">
				<button class="tu-btn blue" href="javascript:void()" (click)="quotationActions('accept')" i18n="@@quotation.accept_quotation" >
					Accept Quotation
				</button>
				
				<button class="tu-btn green" href="javascript:void()" (click)="quotationActions('reject')" data-toggle="modal" data-target="#rejectionreason" i18n="@@quotation.reject_quotation">
					Reject and Negotiate
				</button>
				
				<button class="tu-btn transparent pink" data-toggle="modal" data-target="#reject-modal" href="javascript:void()" (click)="quotationActions('reject-only')" i18n="@@quotation.reject_only">
					Reject Only
				</button>
			</div>
		</div>
	</div>
</div>
